<template>
    <div v-if="page_show" style="padding-top: 1rem">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Submit top up application'"
                  path="/user" :ask="true" :askName="navRecharge[active]"></navTitle>
        <div class="game-tips" v-if="frist_money>0">
            FIRST TIME TOP-UP ₱100 REWARD ₱{{frist_money}}
        </div>
        <div class="isnull" v-if="showTips === 'true'">
            You have not link e-wallet yet, please link and submit top up application again.
            <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
                Link now
            </div>
        </div>

        <div class="recharge" v-if="showTips === 'false'">
            <div class="gift-container" v-if="recharge_gift_is_open">
                <div class="box" v-for="(v, k) in recharge_gift_list" :key="k">
                    <div v-if="v.is_get">
                        <img src="../../assets/images/g3.png" @click="receiveGift()">
                        <div class="bonus-view is-open">{{v.view}}th</div>
                    </div>
                    <div v-else>
                        <img :src="require(`../../assets/images/g${k}.png`)" @click="receiveGift()">
                        <div class="bonus-view">{{v.view}}th</div>
                    </div>
                </div>
            </div>
            <div class="nav acea-row row-around row-middle">
                <div class="item" :class="active === index ? 'on' : ''"
                     v-for="(item, index) in navRecharge" :key="index" @click="navRecharges(index,item)">
                    {{ item==='PayMaya'?'Maya':item }}
                </div>
            </div>
            <p class="switch-info" v-if="navRecharge.length!==0">Please choose the amount and continue</p>
            <div class="info-wrapper">
                <div v-if="switch_cashName=='BinancePay'" class="text_title">1<i> USDT</i> = <i>₱</i>50</div>
                <div class="money-switch">
                    <template v-if="switch_cashName=='GCash'">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.GCash">
                            <div v-if="first_gift_amount_flag">
                                <!--<div v-if="channel_use_info['set_amount'].includes(item)"
                                     :class="{ 'switch-item1': recharged_amount.includes(item), 'switch-item2': !recharged_amount.includes(item), 'switch-click': switch_index === index }"
                                     v-key="index" @click="switchItem(item,index)">-->
                                <div v-if="channel_use_info['set_amount'].includes(item)"
                                     class="switch-item2" :class="{ 'switch-click': switch_index === index }"
                                     v-key="index" @click="switchItem(item,index)">
                                    <div>₱{{item}}</div>
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                                <div v-else class="switch-item2" style="color: #ddd;" v-key="index">
                                    <div>₱{{item}}</div>
                                    <div class="gift-amount">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="channel_use_info['set_amount'].includes(item)"
                                     class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                                <div v-else class="switch-item1" style="color: #ddd;" v-key="index">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="switch_cashName=='PayMaya'">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.PayMaya">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="switch_cashName=='BinancePay'">
                        <div class="switch-item" :class="switch_index===index?'switch-click':''"
                             v-for="(item,index) in money_switch.USDT" v-key="index"
                             @click="switchItem(item,index)">
                            <span class="usdt">
                                <div class="usdt_info2">{{item}} <i style="color: red;font-size: .2rem;">USDT</i></div>
                            </span>
                        </div>
                    </template>
                    <template
                            v-else-if="channel_use_info['safe_pay_channel']!==3&&switch_cashName === channel_use_info['safe_name']">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.WePayO">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''" v-key="index"
                                     @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                        <div class="method">
                            Recharge Method:<select class="select" v-model="paytypecode">
                            <option value="21001"
                                    v-if="channel_use_info['safe_pay_channel']===0&&this.channel_use_info['safe_pay_channels'].includes('1')">
                                GCash
                            </option>
                            <option value="21033"
                                    v-if="channel_use_info['safe_pay_channel']===0&&this.channel_use_info['safe_pay_channels'].includes('5')">
                                GCash-face
                            </option>
                            <option value="21066"
                                    v-if="channel_use_info['safe_pay_channel']===0&&this.channel_use_info['safe_pay_channels'].includes('4')">
                                GCash-official
                            </option>
                            <option value="21003"
                                    v-if="channel_use_info['safe_pay_channel']===0&&this.channel_use_info['safe_pay_channels'].includes('3')">
                                GCash-QR
                            </option>
                            <option value="21002"
                                    v-if="channel_use_info['safe_pay_channel']===0&&this.channel_use_info['safe_pay_channels'].includes('2')">
                                PayMaya
                            </option>
                        </select>
                        </div>
                    </template>
                    <template
                            v-else-if="channel_use_info['we_pay_channel']!==1&&switch_cashName === channel_use_info['we_name']">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.WePayO">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''" v-key="index"
                                     @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                        <div class="method">
                            Recharge Method:<select class="select" v-model="wepaytypecode">
                            <option value="136"
                                    v-if="channel_use_info['we_pay_channel']===0||channel_use_info['we_pay_channel']===2">
                                GC-QR
                            </option>
                            <option value="753"
                                    v-if="channel_use_info['we_pay_channel']===0||channel_use_info['we_pay_channel']===3">
                                GC-Official
                            </option>
                            <!--                                <option value="614" v-if="channel_use_info['we_pay_channel']===0||channel_use_info['we_pay_channel']===4">Maya</option>-->
                        </select>
                        </div>
                    </template>
                    <template
                            v-else-if="channel_use_info['wen_pay_channel']===0&&switch_cashName === channel_use_info['wen_name']">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.WeN">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''" v-key="index"
                                     @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template
                            v-else-if="channel_use_info['r_pay_channel']!==1&&switch_cashName === channel_use_info['r_name']">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.WeN">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''" v-key="index"
                                     @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{gift_list[index]}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                        <div class="method">
                            Recharge Method:<select class="select" v-model="gcash_type">
                            <option value="1"
                                    v-if="channel_use_info['r_pay_channel']===0||channel_use_info['r_pay_channel']===3">
                                GCash-QR
                            </option>
                            <option value="3"
                                    v-if="channel_use_info['r_pay_channel']===0||channel_use_info['r_pay_channel']===2">
                                GCash-Face
                            </option>
                            <option value="4"
                                    v-if="channel_use_info['r_pay_channel']===0||channel_use_info['r_pay_channel']===4">
                                Maya/GCash
                            </option>
                        </select>
                        </div>
                    </template>
                    <template
                            v-else-if="channel_use_info['rn_pay_channel']!==1&&switch_cashName === channel_use_info['rn_name']">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.RpayN">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''" v-key="index"
                                     @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>
                        <div class="method">
                            Recharge Method:<select class="select" v-model="gcash_type_n">
                            <option value="1"
                                    v-if="channel_use_info['rn_pay_channel']===0||channel_use_info['rn_pay_channel']===3">
                                GCash-QR
                            </option>
                            <option value="3"
                                    v-if="channel_use_info['rn_pay_channel']===0||channel_use_info['rn_pay_channel']===2">
                                GCash-Official
                            </option>
                            <!--<option value="4"
                                    v-if="channel_use_info['rn_pay_channel']===0||channel_use_info['rn_pay_channel']===4">
                                Maya/GCash
                            </option>-->
                            <option value="4"
                                    v-if="channel_use_info['rn_pay_channel']!==1">
                                Maya
                            </option>
                        </select>
                        </div>
                    </template>
                    <template
                            v-else-if="channel_use_info['top_pay_channel']!==1&&switch_cashName === channel_use_info['toppay_name']">
                        <div style="width: 33.3%" v-for="(item,index) in money_switch.VIPFast">
                            <div v-if="first_gift_amount_flag">
                                <div class="switch-item2" :class="switch_index==index?'switch-click':''" v-key="index"
                                     @click="switchItem(item,index)">
                                    ₱{{item}}
                                    <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                        <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                        <label v-else>---</label>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                     v-key="index" @click="switchItem(item,index)">
                                    ₱{{item}}
                                </div>
                            </div>
                        </div>

                        <div class="method">
                            Recharge Method:<select class="select" v-model="toppaytypecode">
                            <option value="15"
                                    v-if="channel_use_info['top_pay_channel']===0||channel_use_info['top_pay_channel']===3">
                                GCash
                            </option>
                            <option value="0"
                                    v-if="channel_use_info['top_pay_channel']===0||channel_use_info['top_pay_channel']===2">
                                GCash-QR
                            </option>
                        </select>
                        </div>
                    </template>
                    <template v-else>
                        <p>GCash is under maintenance, please bind PayMaya</p>
                        <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
                            Link now
                        </div>
                    </template>

                </div>
                <div class="tips" v-if="!active">
                    <div v-if="switch_cashName==='BinancePay'">Note:Current balance<span>₱{{ now_money || 0 }} + ₱{{ Math.floor(money * 50) }}</span>
                    </div>
                    <div v-else>Note:Current balance<span>₱{{ now_money || 0 }}</span></div>
                </div>
                <div class="tips" v-else>
                    <div v-if="switch_cashName==='BinancePay'">Note:Current balance<span>₱{{ now_money || 0 }} + ₱{{ Math.floor(money * 50) }}</span>
                    </div>
                    <div v-else>Note:Current balance<span>₱{{ now_money || 0 }}</span></div>
                    <!--                    Note:Current balance<span>₱{{ now_money || 0 }}</span>-->
                </div>
                <div v-if="navRecharge.length!==0" class="pay-btn bg-color-blue" @click="recharge">
                    Confirm top up
                </div>
            </div>
        </div>
        <div class="list" v-if="showTips === 'false' && applyList.length > 0">
            <div class="title">Top up application details</div>
            <div style="color: red;margin-top: 3px">* If it takes more than 10 minutes without success, you can send a
                screenshot of the order number and transaction details to cs
            </div>
            <div class="li" v-for="item in applyList">
                <div class="row">Order number:{{ item.order_id }}</div>
                <div class="row">Application time:{{ item.add_time }}</div>
                <div class="row">Top up amount:{{ item.price }}</div>
                <div class="row">
                    Top up status:
                    <span v-if="item.state === 0">
                        <label>Reviewing</label>
                        <label class="fast-btn"
                               v-if="(item.recharge_type==='GCash'||item.recharge_type==='PayMaya')&&item.state===0&&item.paid===0"
                               @click="goOnRecharge(item)">Continue Top-Up</label>
                        <!--                        <label v-if="item.recharge_type==='GCash'" class="fast-btn" @click="rechargeAppeal(item.id)">Fast</label>-->
                    </span>
                    <span v-if="item.state === 1" style="color: #40B883">Application success</span>
                    <span v-if="item.state === 2" style="color: #dd3823">
                        <label>Application failed</label>
                        <!--                        <label v-if="item.recharge_type==='GCash'" class="fast-btn" @click="rechargeAppeal(item.id)">Fast</label>-->
                    </span>
                    <span v-if="item.state === 3" style="color: #dd3823">Under review</span>
                </div>
            </div>
        </div>

        <!--点击礼物弹窗-->
        <div v-if="r_d_pop">
            <div id="forPop" @click="bgClose"></div>
            <div class="all-award-list">
                <div class="rule">
                    ⓘThe {{recharge_gift_list[0].view}}th, {{recharge_gift_list[1].view}}th, and
                    {{recharge_gift_list[2].view}}th users who successfully top up every day will receive
                    {{recharge_gift_list[0].multiple*100}}%, {{recharge_gift_list[1].multiple*100}}%, and
                    {{recharge_gift_list[2].multiple*100}}% bonuses of the top up amount respectively! If you win, claim
                    your prize from the list below.
                    <!--                    第{{n1.view}},{{n2.view}},{{n3.view}}笔充值成功的金额分别可以翻{{n1.multiple}},{{n2.multiple}},{{n3.multiple}}倍,若中奖可以在下列表中领取翻倍的金额-->
                </div>
                <div class="r-title">
                    Recharge Lucky Prize List <!--充值幸运大奖列表-->
                </div>
                <table style="width: 96%;border: 1px;text-align: center;margin-left: 2%;margin-bottom: 10px">
                    <tr style="background: #00c3f9;color: #fff;font-weight: bold;height: 35px">
                        <td>Type</td>
                        <td>Date</td>
                        <td>UID</td>
                        <td>Bonus</td>
                        <td>Operate</td>
                    </tr>
                    <tr style="height: 45px" v-for="(v,k) in r_l_list">
                        <td><img :src="require(`../../assets/images/g${k}.png`)"></td>
                        <td>{{formattedDate(v.add_time)}}</td>
                        <td>{{v.uid}}</td>
                        <td>₱{{v.amount*v.multiple}}</td>
                        <td>
                            <div v-if="v.uid===uid">
                                <div class="re-btn" v-if="v.is_return===0"
                                     @click="receiveBtn(v.id,v.amount*v.multiple)">receive
                                </div>
                                <div class="re-btn received" v-else>received</div>
                            </div>
                            <div v-else>--</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {
        getUser,
        recharge_info,
        recharge_apply,
        check_recharge,
        getTodayRechargeCount,
        recharge_apply_list,
        topPayApply,
        wePayApply,
        wenPayApply,
        rPayApply,
        rNPayApply,
        payment_create,
        getChannelUseInfo,
        getRechargeWelfare,
        getRechargeGift,
        DebounceBy,
    } from "../../api/user";

    // import {pay} from "@libs/wechat";
    import {isWeixin} from "@utils";
    // import {rechargeWechat} from "@api/user";
    // import {add, sub} from "@utils/bc";
    import navTitle from "@components/navTitle";
    import {Field, Popup} from 'mint-ui'
    import 'mint-ui/lib/style.css'

    export default {
        name: "Recharge",
        components: {
            navTitle,
            'mt-field': Field,
            'mt-popup': Popup
        },
        props: {},
        data: function () {
            return {
                // navRecharge: ["账户充值", "佣金导入"],
                navRecharge: [],
                gcash_type: 1,
                gcash_type_n: 1,
                active: 0,
                payType: ["weixin"],
                from: isWeixin() ? "weixin" : "weixinh5",
                money: "100",
                now_money: "",
                showTips: "",
                my_cash: [],
                applyList: [],
                money_switch: {
                    'default': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'GCash': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'TopPay': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'WePayO': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'WePay': [100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000],
                    'RpayN': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'WeN': [400, 1000, 2000, 3000, 5000, 10000, 20000, 30000, 50000],
                    'PayMaya': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'USDT': [1, 2, 5, 10, 20, 50, 100, 200, 500],
                    'VIPFast': [100, 200, 500, 1000, 2000, 5000, 10000, 20000, 40000],
                    'VIP2Fast': [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000],
                    'VIP3Fast': [100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000]
                },

                switch_cashName: "GCash",
                switch_index: 1,
                frist_money: 0,
                recharge_count: 0,
                name: '',
                paytypecode: '21001',
                wepaytypecode: '136',
                wenpaytypecode: '729',
                toppaytypecode: '15',
                // wenpaytypecode: '101',
                channel_use_info: '',
                page_show: false,
                first_gift_amount_flag: false,
                r_d_pop: false,
                recharge_gift_is_open: false,
                r_l_list: [],
                gift_list: [],
                recharge_gift_list: [],
                recharged_amount: [],
                uid: '',
                recharge_appeal_pop: false,
                previewUrl: null,
            };
        },
        computed: mapGetters(["userInfo"]),
        mounted: function () {
            this.now_money = this.userInfo.now_money;
            this.getApplyList();
            this.getChannelUseInfo();
            // this.getTodayRechargeCount();
            this.initGifts();
        },
        watch: {
            $route(n) {
                if (n.name === "Recharge_cash") {
                    if (n.query.r == 1) {
                    }
                }
            }

        },
        methods: {
            convertToObj(arr) {
                const result = {};
                arr.forEach(item => {
                    const [amount, quantity] = item.split(",");
                    result[parseInt(amount)] = parseInt(quantity);
                });
                return result;
            },
            getQuantity(a) {
                const dataObj = this.convertToObj(this.gift_list);
                return dataObj[a] || 0;
            },
            rechargeAppeal(id) {
                this.recharge_appeal_pop = true
                // console.log(id)
            },
            rechargeAppealClose() {
                this.recharge_appeal_pop = false
            },
            handleFileChange(event) {
                // this.selectedFile = event.target.files[0];
                // this.previewUrl = URL.createObjectURL(this.selectedFile);
            },
            getChannelUseInfo() {
                let that = this
                getChannelUseInfo().then(res => {
                    this.getList();
                    that.channel_use_info = res.data
                    that.gift_list = res.data.gift_prop_arr
                    that.recharged_amount = res.data.recharged_amount
                    that.first_gift_amount_flag = res.data.recharge_gift_open === 1 ? true : false
                    // console.log(that.channel_use_info)
                    that.page_show = true
                    // console.log(that.channel_use_info.channel_show)
                }).catch(res => {
                    // console.log(res)
                })
            },

            getTodayRechargeCount() {
                let that = this
                getTodayRechargeCount().then(res => {
                    that.recharge_count = res.data.recharge_count
                    // console.log(that.recharge_count)
                }).catch(res => {
                    // console.log(res)
                })
            },
            switchItem(money, index) {
                // if (!(this.recharge_count > 0 && money === 50)) {
                this.money = money
                this.switch_index = index
                // }
            },
            navRecharges: function (index, name) {
                this.active = index;
                // console.log(this.active)
                this.switch_cashName = name
                this.switch_index = 1
                if (name === 'PayMaya') {
                    this.money = this.money_switch.PayMaya[1]
                } else if (name === 'GCash') {
                    this.money = this.money_switch.GCash[1]
                } else if (name === 'TopPay') {
                    this.money = this.money_switch.TopPay[1]
                    // } else if (name === 'VIPFast') {
                } else if (name === this.channel_use_info['toppay_name']) {
                    this.money = this.money_switch.VIPFast[1]
                    // } else if (name === 'VIP3Fast') {
                } else if (name === this.channel_use_info['safe_name']) {
                    this.money = this.money_switch.WePayO[1]
                } else if (name === this.channel_use_info['we_name']) {
                    this.money = this.money_switch.WePayO[1]
                } else if (name === this.channel_use_info['wen_name']) {
                    this.money = this.money_switch.WeN[1]
                } else if (name === this.channel_use_info['r_name']) {
                    this.money = this.money_switch.WePay[1]
                } else if (name === this.channel_use_info['rn_name']) {
                    this.money = this.money_switch.RpayN[1]
                } else if (name === 'BinancePay') {
                    this.money = this.money_switch.USDT[1]
                } else {
                    this.money = this.money_switch.default[1]
                }
            },
            getList() {
                this.$dialog.loading.open("Loading...");
                recharge_info().then(res => {
                    this.$dialog.loading.close();
                    // this.payList = res.data.types;
                    this.my_cash = res.data.my_cash;
                    // this.my_cash.push({type: 'TopPay'})
                    // console.log(this.my_cash)
                    this.frist_money = res.data.first_recharge_award

                    let my_cash = res.data.my_cash;
                    // console.log(my_cash)
                    /*const index = my_cash.findIndex(item => item.type === 'GCash');
                    if (index !== -1 && parseInt(this.channel_use_info['set_amount'][0]) === 20) {
                        my_cash.splice(index, 1);
                    }*/
                    if (my_cash.length > 0) {
                        my_cash.forEach(
                            item => item.type !== "" && item.type !== "TopPay" && this.navRecharge.push(item.type)
                        );
                        // console.log(my_cash)
                        // console.log(this.channel_use_info['set_amount'])
                        this.showTips = "false";

                        /*if (this.channel_use_info['top_pay_channel'] === 0)
                            this.navRecharge.push(this.channel_use_info['toppay_name'])*/
                        if (this.channel_use_info['r_pay_channel'] !== 1) {
                            this.navRecharge.push(this.channel_use_info['r_name'])
                            if (this.channel_use_info['r_pay_channel'] === 2) {
                                this.gcash_type = 3;
                            } else if (this.channel_use_info['r_pay_channel'] === 4) {
                                this.gcash_type = 4;
                            } else {
                                this.gcash_type = 1;
                            }
                        }
                        if (this.channel_use_info['rn_pay_channel'] !== 1) {
                            this.navRecharge.push(this.channel_use_info['rn_name'])
                            if (this.channel_use_info['rn_pay_channel'] === 2) {
                                this.gcash_type_n = 3;
                            } else if (this.channel_use_info['rn_pay_channel'] === 4) {
                                this.gcash_type_n = 4;
                            } else {
                                this.gcash_type_n = 1;
                            }
                        }
                        if (this.channel_use_info['top_pay_channel'] !== 1) {
                            this.navRecharge.push(this.channel_use_info['toppay_name'])
                            if (this.channel_use_info['top_pay_channel'] === 2) {
                                this.toppaytypecode = '0';
                            } else if (this.channel_use_info['top_pay_channel'] === 3) {
                                this.toppaytypecode = '15';
                            } else {
                                this.toppaytypecode = '15';
                            }
                        }
                        if (this.channel_use_info['safe_pay_channel'] !== 3) {
                            this.navRecharge.push(this.channel_use_info['safe_name'])
                            if (this.channel_use_info['safe_pay_channels'].includes('4')) {
                                this.paytypecode = '21066';
                            } else if (this.channel_use_info['safe_pay_channels'].includes('1')) {
                                this.paytypecode = '21001';
                            } else if (this.channel_use_info['safe_pay_channels'].includes('5')) {
                                this.paytypecode = '21033';
                            } else if (this.channel_use_info['safe_pay_channels'].includes('2')) {
                                this.paytypecode = '21002';
                            } else if (this.channel_use_info['safe_pay_channels'].includes('3')) {
                                this.paytypecode = '21003';
                            } else {
                                this.paytypecode = '21001';
                            }
                        }
                        if (this.channel_use_info['we_pay_channel'] !== 1)
                            this.navRecharge.push(this.channel_use_info['we_name'])
                        if (this.channel_use_info['we_pay_channel'] === 3) {
                            this.wepaytypecode = '753';
                        }
                        if (this.channel_use_info['we_pay_channel'] === 2) {
                            this.wepaytypecode = '136';
                        }
                        if (this.channel_use_info['wen_pay_channel'] === 0)
                            this.navRecharge.push(this.channel_use_info['wen_name'])

                        // console.log(this.navRecharge)
                        if (parseInt(this.channel_use_info['set_amount'][0]) === 0) {
                            const index = this.navRecharge.findIndex(item => item === 'GCash');
                            this.navRecharge.splice(index, 1);
                        }

                        this.switch_cashName = this.navRecharge[0]

                    } else {
                        this.showTips = "true";
                    }
                }).catch(res => {
                    this.$dialog.loading.close()
                    console.log(res)
                })
            },
            getApplyList() {
                recharge_apply_list({
                    page: 1,
                    limit: 999
                }).then(res => {
                    this.applyList = res.data.list;
                });
            },
            recharge: function () {
                let that = this;
                if (this.money > 0) {
                    if (this.money < 50 && this.switch_cashName !== 'BinancePay') {
                        return this.$dialog.toast({mes: "Minimum 50 to top-up"});
                    }
                    // if (this.money < 50 && this.switch_cashName === 'VIPFast') {
                    if (this.money < 100 && this.switch_cashName === this.channel_use_info['toppay_name'] && this.channel_use_info['top_pay_channel'] === 0) {
                        return this.$dialog.toast({mes: "Minimum 100 to top-up"});
                    }
                    if (this.money < 50 && this.switch_cashName === this.channel_use_info['we_name'] && this.channel_use_info['we_pay_channel'] === 0) {
                        return this.$dialog.toast({mes: "Minimum 50 to top-up"});
                    }

                    if (this.money < 400 && this.switch_cashName === this.channel_use_info['wen_name'] && this.channel_use_info['wen_pay_channel'] === 0) {
                        return this.$dialog.toast({mes: "Minimum 400 to top-up"});
                    }

                    if (this.money < 50 && this.switch_cashName === this.channel_use_info['r_name'] && this.channel_use_info['r_pay_channel'] !== 1) {
                        return this.$dialog.toast({mes: "Minimum 100 to top-up"});
                    }

                    if (this.money < 50 && this.switch_cashName === this.channel_use_info['rn_name'] && this.channel_use_info['rn_pay_channel'] !== 1) {
                        return this.$dialog.toast({mes: "Minimum 50 to top-up"});
                    }

                    // if (this.money < 100 && this.switch_cashName === 'VIP3Fast') {
                    if (this.money < 50 && this.switch_cashName === this.channel_use_info['safe_name'] && this.channel_use_info['safe_pay_channel'] !== 3) {
                        return this.$dialog.toast({mes: "Minimum 100 to top-up"});
                    }
                    if (this.money < 1 && this.switch_cashName !== 'BinancePay') {
                        return this.$dialog.toast({mes: "Minimum 1 to top-up"});
                    }

                    /*if (this.recharge_count >= 1 && this.money === 50) {
                        return this.$dialog.toast({mes: "₱50 can only be recharged once a day"});
                    }*/

                    // console.log(that.switch_cashName)
                    // console.log(that.channel_use_info['toppay_name'])
                    // console.log(that.channel_use_info['safe_name'])

                    check_recharge({price: this.money}).then(res => {
                        // console.log(that.switch_cashName)
                        // console.log(that.channel_use_info['we_name'])
                        // console.log(that.channel_use_info['we_pay_channel'])
                        if (that.switch_cashName === 'TopPay') {
                            /*topPayApply({price: that.money}).then(res_app => {
                                window.location.href = res_app.data.payment_link
                                // console.log(res_app)
                            }).catch(err => {
                                that.$dialog.toast({mes: err.msg});
                            })*/
                        } else if (that.switch_cashName === that.channel_use_info['toppay_name'] && that.channel_use_info['top_pay_channel'] !== 1) {
                            that.$dialog.loading.open("loading");
                            // console.log({amount: that.money,gcash_type: that.toppaytypecode})
                            // return
                            getUser().then(res => {
                                if (parseInt(res.data.level) >= parseInt(that.channel_use_info['toppay_use_grade'][0])) {
                                    topPayApply({amount: that.money, gcash_type: that.toppaytypecode}).then(res_app => {
                                        this.$dialog.loading.close()
                                        // console.log(res_app.data)
                                        window.location.href = res_app.data.res.data.paymentValue
                                    }).catch(err => {
                                        this.$dialog.loading.close()
                                        that.$dialog.toast({mes: err.msg});
                                    })
                                } else {
                                    this.$dialog.loading.close()
                                    that.$dialog.toast({mes: "Please use it after reaching the level"});
                                }
                            });
                        } else if (that.switch_cashName === that.channel_use_info['we_name'] && that.channel_use_info['we_pay_channel'] !== 1) {
                            that.$dialog.loading.open("loading");
                            getUser().then(res => {
                                if (parseInt(res.data.level) >= parseInt(that.channel_use_info['wepay_use_grade'][0])) {
                                    // console.log({price: that.money, pay_type: that.wepaytypecode})
                                    // return
                                    wePayApply({price: that.money, pay_type: that.wepaytypecode}).then(res_app => {
                                        this.$dialog.loading.close()
                                        window.location.href = res_app.data.payment_link
                                        // console.log(res_app)
                                    }).catch(err => {
                                        // console.log(err)
                                        this.$dialog.loading.close()
                                        that.$dialog.toast({mes: err.msg});
                                    })
                                } else {
                                    this.$dialog.loading.close()
                                    that.$dialog.toast({mes: "Please use it after reaching the level"});
                                }
                            });
                        } else if (that.switch_cashName === that.channel_use_info['wen_name'] && that.channel_use_info['wen_pay_channel'] === 0) {
                            that.$dialog.loading.open("loading");
                            getUser().then(res => {
                                if (parseInt(res.data.level) >= parseInt(that.channel_use_info['wenpay_use_grade'][0])) {
                                    wenPayApply({price: that.money, pay_type: that.wenpaytypecode}).then(res_app => {
                                        this.$dialog.loading.close()
                                        window.location.href = res_app.data.payment_link
                                        // console.log(res_app)
                                    }).catch(err => {
                                        // console.log(err)
                                        this.$dialog.loading.close()
                                        that.$dialog.toast({mes: err.msg});
                                    })
                                } else {
                                    this.$dialog.loading.close()
                                    that.$dialog.toast({mes: "Please use it after reaching the level"});
                                }
                            });
                        } else if (that.switch_cashName === that.channel_use_info['r_name'] && that.channel_use_info['r_pay_channel'] !== 1) {
                            // that.$dialog.loading.open("loading");
                            // console.log(that.money)
                            // console.log(that.switch_cashName)
                            // console.log(that.channel_use_info['r_name'])
                            getUser().then(res => {
                                // console.log({amount: that.money, gcash_type: that.gcash_type})
                                // return
                                if (parseInt(res.data.level) >= parseInt(that.channel_use_info['rpay_use_grade'][0])) {
                                    rPayApply({amount: that.money, gcash_type: that.gcash_type}).then(res_app => {
                                        this.$dialog.loading.close()
                                        window.location.href = res_app.data.res.redirect_url
                                        // console.log(res_app)
                                    }).catch(err => {
                                        console.log(err)
                                        this.$dialog.loading.close()
                                        that.$dialog.toast({mes: err.msg});
                                    })
                                } else {
                                    this.$dialog.loading.close()
                                    that.$dialog.toast({mes: "Please use it after reaching the level"});
                                }
                            });
                        } else if (that.switch_cashName === that.channel_use_info['rn_name'] && that.channel_use_info['rn_pay_channel'] !== 1) {
                            getUser().then(res => {
                                // console.log({amount: that.money, gcash_type: that.gcash_type})
                                // return
                                if (parseInt(res.data.level) >= parseInt(that.channel_use_info['rpayn_use_grade'][0])) {
                                    rNPayApply({amount: that.money, gcash_type: that.gcash_type_n}).then(res_app => {
                                        this.$dialog.loading.close()
                                        window.location.href = res_app.data.res.redirect_url
                                        // console.log(res_app)
                                    }).catch(err => {
                                        console.log(err)
                                        this.$dialog.loading.close()
                                        that.$dialog.toast({mes: err.msg});
                                    })
                                } else {
                                    this.$dialog.loading.close()
                                    that.$dialog.toast({mes: "Please use it after reaching the level"});
                                }
                            });
                        } else if (that.switch_cashName === that.channel_use_info['safe_name'] && that.channel_use_info['safe_pay_channel'] !== 3) {
                            that.$dialog.loading.open("loading");
                            getUser().then(res => {
                                if (parseInt(res.data.level) >= parseInt(that.channel_use_info['safe_use_grade'][0])) {
                                    that.$dialog.loading.close();
                                    /*that.$router.push({
                                        path: "/user/rechargeMethod",
                                        query: {
                                            m: that.money
                                        }
                                    });*/
                                    const param = {
                                        amount: this.money,
                                        // phone: this.phone,
                                        name: this.name,
                                        // email: this.email,
                                        paytypecode: this.paytypecode
                                    }
                                    // console.log(param)
                                    // return
                                    payment_create(param).then(res => {
                                        this.$dialog.loading.close()
                                        let pay_res = res.data
                                        window.location.href = pay_res.link_url
                                    }).catch(res => {
                                        this.$dialog.loading.close()
                                        return this.$dialog.error(res.data.msg)
                                    })
                                } else {
                                    this.$dialog.loading.close()
                                    that.$dialog.toast({mes: "Please use it after reaching the level"});
                                }
                                // console.log(res.data.level)
                            });
                        } else {
                            let u1_type, cid
                            if (parseInt(this.channel_use_info['set_amount'][0]) === 0 && that.my_cash[that.active].type == 'GCash') {
                                u1_type = 'PayMaya'
                            } else {
                                u1_type = that.my_cash[that.active].type
                            }
                            that.my_cash.forEach(item => {
                                if (item.type === u1_type) {
                                    cid = item.id
                                }
                            });
                            let price = Number(that.money);
                            // let msg = "Please confirm that you have successfully sent the money with the bound "+u1_type+" mobile number! If in doubt, please use Customer service to contact us. "
                            let msg = "Please use your bound wallet to send, otherwise it will not be completed."
                            if (price === 0) {
                                return that.$dialog.toast({mes: "Please enter amount to top up"});
                            } else if (price < 0.01) {
                                return that.$dialog.toast({mes: "Transfer amount minimum of 0.01"});
                            }
                            that.$dialog.confirm({
                                mes: msg,
                                title: "Submit top up application",
                                opts: [
                                    {
                                        txt: "Cancel",
                                        color: false,
                                        callback: () => {
                                            return that.$dialog.toast({mes: "Cancelled"});
                                        }
                                    },
                                    {
                                        txt: "Confirm",
                                        color: "#00C3F9",
                                        callback: () => {
                                            this.$dialog.loading.open('loading...')
                                            recharge_apply({price: price, cash_id: cid}).then(res => {
                                                this.$dialog.loading.close();

                                                that.$dialog.toast({mes: res.msg})

                                                that.$router.push({
                                                    path: "/user/Recharge_cash_info",
                                                    query: {
                                                        m: that.money,
                                                        // u1: that.my_cash[that.active].phone,
                                                        u1: that.my_cash[that.active].phone,
                                                        type: u1_type,
                                                        cid: cid
                                                    }
                                                });
                                            }).catch(res => {
                                                this.$dialog.loading.close();

                                                that.$dialog.toast({mes: res.msg});
                                            });

                                        }
                                    }
                                ]
                            });
                            /*that.$router.push({
                                path: "/user/Recharge_cash_info",
                                query: {
                                    m: that.money,
                                    // u1: that.my_cash[that.active].phone,
                                    u1: that.my_cash[that.active].phone,
                                    type: u1_type,
                                    cid: cid
                                }
                            });*/
                        }
                    }).catch(res => {
                        console.log(res)
                        this.$dialog.toast({mes: res.msg});
                    });
                } else {
                    this.$dialog.toast({mes: "Please enter top up amount"});
                }
            },
            goOnRecharge(v) {
                this.$router.push({
                    path: "/user/Recharge_cash_info",
                    query: {
                        m: parseInt(v.price),
                        u1: this.my_cash[this.active].phone,
                        type: v.recharge_type,
                        cid: v.cash_id
                    }
                });
            },
            initGifts() {
                let that = this
                getRechargeWelfare().then(res => {
                    // console.log(res)
                    that.uid = res.data.uid
                    that.recharge_gift_list = res.data.gift_list
                    that.r_l_list = res.data.award_list
                    that.recharge_gift_is_open = parseInt(res.data.is_open) === 1 ? true : false
                })
            },
            receiveGift() {
                this.initGifts()
                this.r_d_pop = true
                // console.log(v)
            },
            bgClose() {
                this.r_d_pop = false
            },
            formattedDate(timestamp) {
                const date = new Date(timestamp * 1000) // 乘以1000将秒转换为毫秒
                return date.toLocaleDateString() // 使用toLocaleDateString()格式化日期
                /*const year = date.getFullYear();
                const month = date.getMonth() + 1; // 月份从0开始，所以需要加1
                const day = date.getDate();
                return `${year}-${month}-${day}`;*/
            },
            receiveBtn: DebounceBy(function (id, amount) {
                const param = {id: id}
                let that = this
                that.$dialog.loading.open("loading");
                getRechargeGift(param).then(res => {
                    if (res.status === 200) {
                        that.now_money = parseInt(that.now_money) + amount
                        that.initGifts()
                        that.$dialog.loading.close()
                        that.$dialog.toast({mes: res.msg});
                    }
                }).catch(err => {
                    this.$dialog.loading.close()
                    that.$dialog.toast({mes: err.msg});
                })
            }, 3000)
        }
    };
</script>
<style scoped>
    #bg-50 {
        color: darkgrey;
    }

    .text_title {
        margin-top: -3px;
        margin-bottom: 2.5px;
        color: red;
    }

    #iframe {
        display: none;
    }

    .game-tips {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
        background: rgba(254, 211, 44, 0.6);
        color: #333;
        position: fixed;
        text-align: center;
        top: 1rem;
        left: 0px;
        right: 0px;
        z-index: 3000;
    }

    .recharge {
        width: 7.03rem;
        padding: 0.5rem 0.63rem 0.45rem;
        background-color: #fff;
        margin: 0.2rem auto 0 auto;
        border-radius: 0.1rem;
    }

    .recharge .nav {
        height: 0.75rem;
        line-height: 0.75rem;
        /*padding: 0 1rem;*/
        margin-bottom: .1rem;
    }

    .recharge .nav .item {
        font-size: 0.3rem;
        color: #333;
    }

    .recharge .nav .item.on {
        font-weight: bold;
        border-bottom: 0.04rem solid #00c3f9;
    }

    .recharge .info-wrapper {
        text-align: center;
    }

    .recharge .info-wrapper .money {
        margin-top: 0.6rem;
        padding-bottom: 0.2rem;
        border-bottom: 1px dashed #ddd;
    }

    .recharge .info-wrapper .money span {
        font-size: 0.56rem;
        color: #333;
        font-weight: bold;
    }

    .recharge .info-wrapper .money input {
        display: inline-block;
        width: 3rem;
        font-size: 0.84rem;
        text-align: center;
        color: #282828;
        font-weight: bold;
        padding-right: 0.7rem;
    }

    .recharge .info-wrapper .money input::placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-webkit-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-ms-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .tips {
        font-size: 0.26rem;
        color: #888;
        margin: 0.25rem auto 0 auto;
        line-height: 1.5;
        padding: 0 0.3rem;
    }

    .recharge .info-wrapper .tips span {
        color: #ef4a49;
    }

    .recharge .info-wrapper .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .list {
        width: 100%;
        padding: 0 0.3rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        background: #fff;
    }

    .list .title {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.3rem;
        border-bottom: 2px solid #00c3f9;
        text-align: center;
    }

    .list .li {
        margin-bottom: 0.15rem;
        border-bottom: 1px dashed #ccc;
        margin-top: 0.15rem;
    }

    .list .li {
        padding: 0.15rem 0;
    }

    .list .li .row {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .money-switch {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .money-switch .switch-item {
        width: 30%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        margin-right: 10px;
        color: #333;
        font-size: 0.4rem;
    }

    .money-switch .switch-item1 {
        width: 90%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        margin-right: 10px;
        color: #333;
        font-size: 0.4rem;
    }

    .money-switch .switch-item2 {
        width: 90%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 35px;
        margin-right: 10px;
        color: #333;
        font-size: 0.4rem;
    }

    .gift-amount {
        width: 86%;
        margin-left: 7%;
        border-top: 1px dashed darkgrey;
        color: darkgrey;
        font-size: .3rem;
    }

    .money-switch .switch-item1:nth-child(3n) {
        margin-right: 0px;
    }

    .money-switch .switch-item2:nth-child(3n) {
        margin-right: 0px;
    }

    .money-switch .switch-item:nth-child(3n) {
        margin-right: 0px;
    }

    .switch-click {
        border: 1px solid #00c3f9 !important;
        color: #00c3f9 !important;

    }

    .gift-switch-click {
        font-weight: bold;
        color: goldenrod !important;

    }

    .switch-info {
        margin-bottom: 10px;
        color: #666;
        /*text-align: center;*/
    }

    .usdt {
        font-size: .3rem;
    }

    .usdt_info2 {
        margin: 0;
        font-size: .3rem;
        height: .3rem;
        position: relative;
    }

    .method {
        color: #d4d8dd;
        width: 100%;
    }

    .select, .input {
        border: 1px solid #d4d8dd;
        height: .5rem;
        width: 45%;
        text-align: center;
        color: #3A3A3A;
        margin-bottom: 5px;
    }

    .gift-container {
        display: flex;
        justify-content: space-between;
        margin-top: -20px;
    }

    .box {
        flex: 1;
        /*background-color: lightgray;*/
        text-align: center;
        padding: 10px;
        /*border: 1px solid gray;*/
    }

    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    #forPop1 {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .all-award-list {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        /*height: 370px;*/
        height: auto;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        /*position: fixed;*/
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
        text-align: center;
    }

    .rule {
        padding: 3px 5px;
        font-size: .2rem;
        color: orangered;
        text-align: left;
    }

    .r-title {
        font-size: .3rem;
        color: darkgrey;
        padding: 3px;
    }

    .re-btn {
        color: #fff;
        background-color: #00c3f9;
        padding: 3px 1px;
        border-radius: 3px;
    }

    .received {
        background-color: darkgrey;
    }

    .fast-btn {
        display: inline-block;
        margin-left: 10%;
        border: 2px solid #00c3f9;
        padding: 0 10px;
        border-radius: 3px;
        color: #333333;
    }

    .image-upload {
        position: relative;
        width: 120px;
        height: 120px;
        border: 2px dashed #888;
        border-radius: 4px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        left: -160px;
    }

    #file-input {
        display: none;
    }

    .image-preview {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .image-preview img {
        max-width: 100%;
        max-height: 100%;
    }

    .placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        font-size: 16px;
        color: #f0f7ff;
    }
    .bonus-view{
        font-size: .25rem;
        color: #3a3a3a;
    }
    .is-open{
        color: #d4d8dd;
        text-decoration: line-through;
    }
</style>
